import React, { useState, useEffect } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
// import { Formik, Form } from 'formik';

import AddressForm from './Forms/AddressForm';
import PersonalFormHrInspect from './Forms/PersonalFormHrInspect';
import PaymentForm from './Forms/PaymentForm';
import ReviewOrder from './ReviewOrder';
import CheckoutSuccess from './CheckoutSuccess';
import validationSchema from './FormModel/validationSchema';
import checkoutFormModel from './FormModel/checkoutFormModel';
import formInitialValues from './FormModel/formInitialValues';
import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData, clearFileData, UploadService } from 'actions/counter';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  useNavigate,
  useRouteMatch,
  Navigate,
  Outlet,
} from 'react-router-dom';
import data from './PersonProperties';
import useStyles from './styles';
import UserService from 'services/user.service';
import AlertMsg from './AlertMsg';
import { formatDateYYYYMMDD } from 'common/DateUtils';

const { shortingPositions, hrChief } = data;
/* copy มาจาก EmploymentPage.js */

//@001 get employee data
//@002 mapping
//@003 save --> hr.cis.routes2.js --> CIS.js --> insertOrUpdateEmployee

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'ต้องไม่ประกอบด้วยตัวเลข')
    .required('ชื่อ isrequired'),
  lastName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'นามสกุลต้องไม่ประกอบด้วยตัวเลข')
    .required('นามสกุล is required'),
  engTitle: yup
    .object()
    .required()
    .typeError('คำนำหน้า(ภาษาอังกฤษ) is required'),
  nameEng: yup
    .string()
    .matches(/^([^0-9]*)$/, 'ชื่อ-นามสกุล(ภาษาอังกฤษ) ต้องไม่ประกอบด้วยตัวเลข')
    .required('ชื่อ-นามสกุล(ภาษาอังกฤษ) is required'),
  idCard: yup.string().required('เลขประจำตัวประชาชน is required'),
  empNationality: yup.string().required('สัญชาติ is required'),
  placeOfBirth: yup.object().required().typeError('ภูมิลำเนา is required'),
  empWeight: yup.number().required().typeError('น้ำหนัก is required'),
  empHeight: yup.number().required().typeError('ส่วนสูง is required'),
  birthdate: yup.mixed().required('วัน/เดือน/ปีเกิด is required'),
  presentAddressEmail: yup
    .string()
    .email('กรุณากรอก email ให้ถูกต้อง')
    .required('email is required'),
  presentAddressCellPhone: yup.string().required('เบอร์โทรศัพท์ is required'),
  royalRankType: yup
    .string()
    .nullable()
    .test(
      'royalRankType-required',
      'ประเภทยศ is required when ยศ is filled',
      function (value) {
        const { royalRank } = this.parent;
        if (royalRank && royalRank !== '') {
          return value && value !== '';
        }
        return true;
      }
    ),
  royalRank: yup
    .string()
    .nullable()
    .test(
      'royalRank-required',
      'ยศ is required when ประเภทยศ is filled',
      function (value) {
        const { royalRankType } = this.parent;
        if (royalRankType && royalRankType !== '') {
          return value && value !== '';
        }
        return true;
      }
    ),
  emergencyFirstName: yup.string().required('ชื่อผู้ติดต่อฉุกเฉิน is required'),
  emergencyLastName: yup
    .string()
    .required('นามสกุลผู้ติดต่อฉุกเฉิน is required'),
  emergencyPhone: yup.string().required('เบอร์โทรศัพท์ is required'),
  medicalProblem: yup.string().required('โรคประจำตัว is required'),
  homeAddressNo: yup
    .string()
    .required('บ้านเลขที่(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressProvince: yup
    .object()
    .required()
    .typeError('จังหวัด(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressDistrict: yup
    .object()
    .required()
    .typeError('อำเภอ(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressTambol: yup
    .object()
    .required()
    .typeError('ตำบล(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressPostal: yup
    .string()
    .required('รหัสไปรษณีย์(ที่อยู่ตามทะเบียนบ้าน) is required'),
  presentAddressNo: yup
    .string()
    .required('บ้านเลขที่(ที่อยู่ปัจจุบัน) is required'),
  presentAddressProvince: yup
    .object()
    .required()
    .typeError('จังหวัด(ที่อยู่ปัจจุบัน) is required'),
  presentAddressDistrict: yup
    .object()
    .required()
    .typeError('อำเภอ(ที่อยู่ปัจจุบัน) is required'),
  presentAddressTambol: yup
    .object()
    .required()
    .typeError('ตำบล(ที่อยู่ปัจจุบัน) is required'),
  presentAddressPostal: yup
    .string()
    .required('รหัสไปรษณีย์(ที่อยู่ปัจจุบัน) is required'),
  workOnRemoteSite: yup
    .string()
    .required('ปฏิบัติงานต่างจังหวัดเป็นการประจำ is required'),
  workOnRemoteSiteOccasion: yup
    .string()
    .required('ปฏิบัติงานต่างจังหวัดเป็นครั้งคราว is required'),
  educations: yup
    .array()
    .of(
      yup.object().shape({
        eduClass: yup.string().required('ระดับชั้น / หลักสูตร is required'),
        eduNameAndPlace: yup
          .object()
          .required()
          .typeError('ชื่อและที่ตั้งสถานศึกษา is required')
          .test(
            'has-valid-id',
            'ชื่อและที่ตั้งสถานศึกษา is required',
            (value) => {
              // ตรวจสอบว่า object มี id หรือ codeSAP ที่ไม่ว่าง
              return value && value.codeSAP;
            }
          ),
        dateFrom: yup
          .string()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) => ['11', '21', '31', '41', '51'].includes(eduClass),
            then: (schema) =>
              schema
                .required('ระยะเวลาจาก is required')
                .typeError('ระยะเวลาจาก is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        dateTo: yup
          .string()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) => ['11', '21', '31', '41', '51'].includes(eduClass),
            then: (schema) =>
              schema
                .required('ระยะเวลาถึง is required')
                .typeError('ระยะเวลาถึง is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        eduGradeScore: yup
          .string()
          .required('เกรดเฉลี่ย/ผลการศึกษา is required'),
        eduCertificate: yup
          .object()
          .required()
          .typeError('ชื่อคุณวุฒิ is required')
          .test('has-valid-id', 'ชื่อคุณวุฒิ is required', (value) => {
            return value && value.codeSAP;
          }),
        branchOfStudy: yup
          .object()
          .required()
          .typeError('สาขาที่จบ is required')
          .test('has-valid-id', 'สาขาที่จบ is required', (value) => {
            return value && value.codeSAP;
          }),
        graduateDate: yup
          .mixed()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .required('วันที่จบการศึกษา is required')
          .typeError('วันที่จบการศึกษา is required'),
        country: yup
          .object()
          .required()
          .typeError('ประเทศ is required')
          .test('has-valid-id', 'ประเทศ is required', (value) => {
            return value && value.id;
          }),
        privateOrGovernment: yup
          .string()
          .required('ประเภทสถานศึกษารัฐบาล/เอกชน is required'),
        duration: yup
          .number()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) => ['11', '21', '31', '41', '51'].includes(eduClass),
            then: (schema) =>
              schema
                .required('ระยะเวลาหลักสูตร is required')
                .typeError('ระยะเวลาหลักสูตร is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        honors: yup
          .object()
          .required()
          .typeError('เกียรตินิยม is required')
          .test('has-valid-id', 'เกียรตินิยม is required', (value) => {
            return value && value.id;
          }),
        instituteOther: yup
          .string()
          .nullable()
          .when('eduNameAndPlace', {
            is: (eduNameAndPlace) => eduNameAndPlace?.codeSAP === '99999999',
            then: (schema) =>
              schema.required('กรุณาระบุสถาบันอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        branchOther: yup
          .string()
          .nullable()
          .when('branchOfStudy', {
            is: (branchOfStudy) => branchOfStudy?.codeSAP === '99999',
            then: (schema) => schema.required('กรุณาระบุสาขาอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        certificateOther: yup
          .string()
          .nullable()
          .when('eduCertificate', {
            is: (eduCertificate) => eduCertificate?.codeSAP === 'N/A',
            then: (schema) =>
              schema.required('กรุณาระบุคุณวุฒิอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
      })
    )
    .min(1)
    .required(),
  isWorkExperience: yup.string().required('ประสบการณ์ทำงาน is required'),
  workExperience: yup
    .array()
    .of(
      yup.object().shape({
        workName: yup.string().required('ชื่อหน่วยงาน is required'),
        workDuty: yup
          .object()
          .required()
          .typeError('ตำแหน่ง is required')
          .test('has-valid-id', 'ตำแหน่ง is required', (value) => {
            // ตรวจสอบว่า object มี id หรือ codeSAP ที่ไม่ว่าง
            return value && value.codeSAP;
          }),
        workSalary: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === '' ? undefined : value;
          })
          .required('อัตราเงินเดือน (บาท) is required')
          .typeError('อัตราเงินเดือน (บาท) is required'),
        workPeriod: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === '' ? undefined : value;
          })
          .required('เป็นระยะเวลา (ปี) is required')
          .typeError('เป็นระยะเวลา (ปี) is required'),
        careerOther: yup
          .string()
          .nullable()
          .when('workDuty', {
            is: (workDuty) => workDuty?.codeSAP === '00000098',
            then: (schema) =>
              schema.required('กรุณาระบุตำแหน่งอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        startDate: yup
          .mixed()
          .nullable().notRequired(),
          // .transform((value, originalValue) => {
          //   return originalValue === '' ? null : value;
          // })
          // .required('วันที่เริ่มงาน is required')
          // .typeError('วันที่เริ่มงาน is required'),
        endDate: yup
          .mixed()
          .nullable().notRequired(),
          // .transform((value, originalValue) => {
          //   return originalValue === '' ? null : value;
          // })
          // .when('isUntilNow', {
          //   // ถ้าเลือกว่า "ยังทำงานอยู่" ให้ endDate ไม่บังคับ
          //   is: (flag) => flag === true || flag === 1 || flag === '1' || flag === 'Y' || flag === 'true',
          //   then: (schema) => schema.notRequired(),
          //   otherwise: (schema) =>
          //     schema
          //       .required('วันที่สิ้นสุดงาน is required')
          //       .typeError('วันที่สิ้นสุดงาน is required'),
          // }),
        isUntilNow: yup.boolean().notRequired(),
      })
    )
    .when('isWorkExperience', {
      is: (isWorkExperience) => isWorkExperience == 'Y',
      then: (schema) => schema.min(1).required('ประสบการณ์ทำงาน is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCert: yup
    .string()
    .required('ใบอนุญาตประกอบวิชาชีพวิศวกรรม is required'),
  engineerCertNo: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('เลขที่ใบประกอบวิชาชีพ is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertProvider: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) =>
      schema.required('หน่วยงานผู้ออกใบประกอบวิชาชีพ is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertStartDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .when('engineerCert', {
      is: (engineerCert) => engineerCert == 'Y',
      then: (schema) =>
        schema
          .required('วันที่อนุญาต is required')
          .typeError('วันที่อนุญาต is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCertEndDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .when('engineerCert', {
      is: (engineerCert) => engineerCert == 'Y',
      then: (schema) =>
        schema
          .required('วันหมดอายุ is required')
          .typeError('วันหมดอายุ is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCertMemberNo: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('หมายเลขสมาชิกสภาวิศวกร is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertType: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('ประเภทใบกว. is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertBranch: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('สาขา is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  englishLanguageCertificate: yup
    .string()
    .nullable()
    .required('ประกาศณียบัตรทางภาษา is required'),
  englishLanguageCertificateScore: yup
    .string()
    .nullable()
    .when('englishLanguageCertificate', {
      is: (englishLanguageCertificate) =>
        ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
      then: (schema) => schema.required('คะแนน is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

  englishLanguageCertificateDate: yup
    .mixed()
    .nullable()
    .when('englishLanguageCertificate', {
      is: (englishLanguageCertificate) =>
        ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
      then: (schema) => schema.required('วันที่สอบ is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  // englishLanguageCertificateNo: yup
  //   .string()
  //   .nullable()
  //   .when('englishLanguageCertificate', {
  //     is: (englishLanguageCertificate) =>
  //       ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
  //     then: (schema) => schema.required('เลขที่ประกาศณียบัตร is required'),
  //     otherwise: (schema) => schema.notRequired(),
  //   }),
  // isPersonalDataProtectionAct: yup
  //   .boolean()
  //   .required('คำรับรองผู้สมัคร is required'),
  acceptConsent: yup.string().required('คำยินยอม is required').nullable(),
  startWorkDate: yup.mixed().required('วันที่เริ่มงาน is required'),
  endWorkDate: yup.mixed().required('ถึงวันที่ is required'),
  signDate: yup.mixed().required('วันที่ทำหลักฐาน is required'),
  position: yup.string().nullable().required('ตำแหน่ง is required'),
  empDivision: yup.string().nullable().required('สังกัด is required'),
  // workLocation: yup
  //   .object()
  //   .required('สถานที่ทำงาน is required')
  //   .typeError('สถานที่ทำงาน is required'),
  psArea: yup.string().nullable().required('PS Area is required'),
  psGroup: yup.string().nullable().required('PS Group is required'),
  salary: yup.number().required('รวม is required'),
});

const steps = [
  'Personal information',
  // 'Address information',
  // 'Education information',
  'Review information',
];

export default function EmploymentPage({ idCard }) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [errMsg, setErrMsg] = useState('');
  const [errMsgDialog, setErrMsgDialog] = useState('');
  const [sapErrorMsg, setSapErrorMsg] = useState('');
  const currentValidationSchema = validationSchema[activeStep];
  const { user: currentUser } = useSelector((state) => state.auth);
  const [formValues, setFormValues] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isLastStep = activeStep === steps.length - 1;
  const { formId, formField } = checkoutFormModel;
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);
  const [isSendingToSAP, setIsSendingToSAP] = useState(false);
  const [honorsOptions, setHonorsOptions] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      empNationality: 'ไทย',
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });
  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };

  const vEmpNo = useWatch({
    control,
    name: 'empNo',
  });

  // const { useForm } = rhf;

  // console.log('---EmploymentPage---isSubmitting----' + isSubmitting);
  // console.log('---EmploymentPage---errors----' + JSON.stringify(errors));

  async function _submitFormRhf(data) {
    await _sleep(1000);

    //แสดงข้อมูลก่อนส่ง
    // alert(JSON.stringify(data, null, 2));
    // actions.setSubmitting(false);

    // insert TO DB
    const isSuccess = await addEmployee(data);
    if (!isSuccess) {
      alert(errMsg);
    } else {
      setActiveStep(activeStep + 1);
    }
  }

  const onSubmit = (data) => {
    // console.log('--------EmploymentPage---onSubmit-------001');
    if (isLastStep) {
      setIsSubmittingFinal(true);
      _submitFormRhf(data);
    } else {
      // console.log('--------EmploymentPage---onSubmit-------002');
      setActiveStep(activeStep + 1);
      // actions.setTouched({});
      // actions.setSubmitting(false);
    }
    // console.log('data', data);
  };

  //https://codesandbox.io/s/react-hook-form-validation-yup-mrv28?file=/src/index.js:688-747
  const onError = (errors) => {
    console.log('--------EmploymentPage---onError-------');
    console.log(errors);

    let errArr = [];

    // Extract all error messages including nested array errors
    Object.keys(errors).forEach((key) => {
      if (['educations']?.includes(key) && Array.isArray(errors[key])) {
        // Handle educations array errors
        errors[key].forEach((eduErr, index) => {
          if (eduErr) {
            Object.keys(eduErr).forEach((field) => {
              if (eduErr[field]?.message) {
                errArr.push({
                  message: `การศึกษา ${index + 1}: ${eduErr[field].message}`,
                });
              }
            });
          }
        });
      } else if (
        ['workExperience']?.includes(key) &&
        Array.isArray(errors[key])
      ) {
        // Handle workExperience array errors
        errors[key].forEach((workErr, index) => {
          if (workErr) {
            Object.keys(workErr).forEach((field) => {
              if (workErr[field]?.message) {
                errArr.push({
                  message: `ประสบการณ์ทำงาน ${index + 1}: ${
                    workErr[field].message
                  }`,
                });
              }
            });
          }
        });
      } else if (errors[key]?.message) {
        // Handle regular field errors
        errArr.push(errors[key]);
      }
    });

    setErrMsgDialog(errArr);
    handleClickOpenErrorDialog();
  };

  //https://www.geeksforgeeks.org/react-mui-dialogcontent-api/
  function SimpleDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
      onClose();
    };

    const render1 = (data) => {
      let v = [];
      //prevent is not a function ถ้ายังไม่มีค่า
      if (data) {
        data.forEach((v2) => {
          // console.log(v2.message);
          // https://www.samanthaming.com/tidbits/87-5-ways-to-append-item-to-array/
          // v = v.concat(v2.message);
          v.push(v2.message);
        });
      }
      return v.map((v2) => (
        <>
          {v2}
          <br />
        </>
      ));
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle style={{ color: '#4682B4' }}>Required Field</DialogTitle>
        <DialogContent dividers>
          <p style={{ margin: 10 }}>
            {/* Most popular course on DSA trusted by over 75,000 students! Built
            with years of experience by industry experts and gives you a
            complete package of video lectures, practice problems, quizzes,
            discussion forums and contests.
            <br />
            Start Today !
            <br /> */}
            {/* {JSON.stringify(errMsgDialog)} */}
            {render1(errMsgDialog)}
          </p>
        </DialogContent>
      </Dialog>
    );
  }

  const getPositionShortName = (positionName) => {
    if (!positionName) return positionName;
    const shortName = shortingPositions.filter(
      ({ label }) => label === positionName
    );

    if (shortName.length > 0) {
      return shortName[0].value;
    } else {
      return positionName;
    }
  };
  //@002 mapping
  const updateForm = (data) => {
    console.log('updateForm: ', data);
    // setFormValues(() => {
    //   return {
    //     ...formInitialValues,
    //     lastName: 'ทดสอบ',
    //   };
    // });
    // const [
    //   {
    //     firstName: vFirstName,
    //     lastName: vLastName,
    //     presentAddress,
    //     durationOfCourse: vDurationOfCourse,
    //   },
    // ] = data;

    //ค่าจาก database
    //create object emp
    const {
      emp: {
        positionType: vPositionType,
        applicantNo: vApplicantNo,
        applicantId,
        title: vTitle,
        idCard: vIdCard,
        firstName: vFirstName,
        lastName: vLastName,
        presentAddress,
        engName: vEngName,
        engTitleId,
        engTitleName,
        nickName: vNickName,
        royalRankType,
        royalRank,
        weight: vEmpWeight,
        height: vEmpHeight,
        bloodGroupId: vBloodType,
        homeAddress: vHomeAddress,
        homeProvinceId,
        homeTambolId,
        homePostalCode: vHomePostalCode,
        presentAddress: vPresentAddressNo,
        // registProvinceId,
        homeProvinceCodeSAP,
        homeProvinceName,
        // registTambolId,
        homeTambolName,
        homeTambolDistrictId,
        homeTambolProvinceId,
        homeDistrictId,
        homeDistrictName,
        homeDistrictProvinceId,
        presentProvinceId,
        presentDistrictId,
        presentTambolId,
        presentProvinceCodeSAP,
        presentProvinceName,
        presentTambolName,
        presentDistrictName,
        presentPostalCode,
        nationality,
        placeOfBirthProvinceId,
        placeOfBirthProvinceCodeSAP,
        placeOfBirthProvinceName,
        medicalProblem,
        mobileNo,
        email,
        emergencyTitle,
        emergencyTitleName,
        emergencyFirstName,
        emergencyLastName,
        emergencyRelationship,
        emergencyAddress,
        emergencyMobileNo,
        workOnRemoteSite,
        workOnRemoteSiteOccasion,
        degreeCode,
        computerSkill: vComputerSkill,
        otherComputerSkill,
        otherSkillDetail: vComment,
        militaryStatusId: vMilitaryStatus,
        militaryExceptReason: vMilitaryExceptReason,
        marriageStatus,
        spouseName,
        numberOfChildren,
        spouseOffice,
        spousePhone,
        birthdate,
        acceptConsent,
        isPersonalDataProtectionAct,
        empNo,
        signDate,
        salary,
        psArea,
        psGroup,
        startWorkDate,
        orgCode,
        empSection,
        empDepartment,
        empDivision,
        employmentRateId,
        employmentRateName,
        englishLanguageCertificate,
        englishLanguageCertificateScore,
        englishLanguageCertificateDate,
        englishLanguageCertificateNo,
        workLocation,
        position,
        positionLevel,
        positionText,
        hrHeadCode,
        hrHeadName,
        hrHeadIdCard,
        // hrHead: { empNo, empName },
      },
      edu,
      // edu: [{ durationOfCourse }],
      engineerCert,
      skillLanguage,
      workHistory,
      trainingHistory,
    } = data;

    const transformed = data.edu?.map(({ durationOfCourse, startDate }) => ({
      eduPeriod: durationOfCourse,
      eduYearFrom: startDate,
    }));

    const vHomeAddressProvince = {
      id: homeProvinceId,
      codeSAP: homeProvinceCodeSAP,
      name: homeProvinceName,
    };

    const vHomeAddressTambol = {
      id: homeTambolId,
      name: homeTambolName,
      // districtId: registTambolDistrictId,
      // provinceId: registTambolProvinceId,
    };

    const vEmploymentRate = {
      id: employmentRateId || 29,
      name: employmentRateName || 'อัตราสรรหาภายนอกปี ๒๕๖๘',
    };

    const vHrHead = {
      empNo: hrHeadCode,
      empName: hrHeadName,
      idCard: hrHeadIdCard,
    };

    // const vRegistAddressTambol = {
    //   id: '2185',
    //   name: 'ตาจง',
    //   // districtId: registTambolDistrictId,
    //   // provinceId: registTambolProvinceId,
    // };

    // console.log(
    //   '-------000001-----vRegistAddressTambol---' +
    //     JSON.stringify(vRegistAddressTambol)
    // );

    const vHomeAddressDistrict = {
      id: homeDistrictId,
      name: homeDistrictName,
      // provinceId: registDistrictProvinceId,
    };

    // console.log(
    //   '-------000002-----vRegistAddressDistrict---' +
    //     JSON.stringify(vRegistAddressDistrict)
    // );

    const vPresentAddressProvince = {
      id: presentProvinceId,
      codeSAP: presentProvinceCodeSAP,
      name: presentProvinceName,
    };

    const vPresentAddressTambol = {
      id: presentTambolId,
      name: presentTambolName,
    };

    const vPresentAddressDistrict = {
      id: presentDistrictId,
      name: presentDistrictName,
    };

    const vPlaceOfBirthProvince = {
      id: placeOfBirthProvinceId,
      codeSAP: placeOfBirthProvinceCodeSAP,
      name: placeOfBirthProvinceName,
    };

    const vWorkHistory = workHistory.map((work) => {
      return {
        workName: work.employer,
        workDuty: { name: work.career || '', codeSAP: work.careerCode || '' },
        careerOther: work.careerOther || null,
        workSalary: work.salaryRate,
        workPeriod: +work.workPeriod,
        startDate: work.startDate,
        endDate: work.endDate,
        isUntilNow: work.isUntilNow,
      };
    });

    const vTrainingHistory = trainingHistory.map((his) => {
      return {
        companyName: his.companyName,
        year: his.trainingYear,
      };
    });

    const vEducation = edu.map((e) => {
      return {
        eduNameAndPlace: {
          id: e?.instituteCode || '',
          codeSAP: e?.instituteCode || '',
          name: e?.instituteName || '',
        },

        // eduNameAndPlace: e?.instituteName || '---',
        // instituteId: e?.instituteId || '',
        // institute: e?.instituteId || '',
        // instituteCode: e?.instituteCode || '',
        dateFrom: e?.dateFrom || '',
        dateTo: e?.dateTo || '',
        eduGradeScore: e?.grade || '',
        eduClass: e?.degreeId || '',
        branchOfStudy: {
          id: e?.branchId || '',
          codeSAP: e?.branchCodeSAP || '',
          name: e?.branchName || '',
        },
        eduCertificate: {
          id: e?.certificateId || '',
          codeSAP: e?.certificateCodeSAP || '',
          name: e?.certificateName || '',
        },
        graduateDate: e?.graduateDate || '',
        inOutCountry: e?.inOutCountry || '',
        countryId: e?.countryId,
        privateOrGovernment: e?.privateOrGovernment || '',
        duration: e?.duration || '',
        isMainEducation: e?.isMainEducation,
        honors: {
          id: e?.honorsId || '',
          name: e?.honorsName || '',
        },
        country: {
          id: e?.countryCode || '',
          name: e?.countryName || '',
        },
        certificateOther: e?.certificateOther || '',
        branchOther: e?.branchOther || '',
        instituteOther: e?.instituteOther || '',
      };
    });

    //ไม่ได้ใช้
    const data2 = {
      ...formInitialValues,
      firstName: vFirstName,
      lastName: vLastName,
      educations: transformed,
      // educations: [
      //   {
      //     eduPeriod: durationOfCourse,
      //     eduYearFrom: '2',
      //     eduYearTo: '3',
      //   },
      // ],
    };
    // setFormValues(data2);

    //react-hook-from initial & transform data

    // console.log('----EmploymentPage.jsx --> homeDistrictId----' + homeDistrictId);

    //mapping DB field to Frontend field
    const dataFromServer = {
      positionType: vPositionType,
      applicantNo: vApplicantNo,
      // salutations: '',
      title: vTitle,
      firstName: vFirstName,
      lastName: vLastName,
      engTitle: engTitleId ? {
        id: engTitleId,
        name: engTitleName,
      } : null,
      nameEng: vEngName,
      idCard: vIdCard,
      nickName: vNickName,
      empWeight: vEmpWeight,
      empHeight: vEmpHeight,
      royalRankType,
      royalRank,
      bloodType: vBloodType,
      isForeigner: 'N',
      addressPass15yr: [
        {
          // yearFrom: '2020',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
        {
          // yearFrom: '2021',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
      ],
      homeAddressNo: vHomeAddress,
      homeAddressProvince: vHomeAddressProvince,
      // homeAddressProvince: {
      //   id: 11,
      //   codeSAP: '09',
      //   name: 'ชลบุรี',
      // },
      homeAddressDistrict: vHomeAddressDistrict,
      // homeAddressDistrict: { id: 138, name: 'หนองใหญ่' },
      // homeAddressDistrict: {
      //   id: homeDistrictId,
      //   name: homeDistrictName,
      // },
      homeAddressTambol: vHomeAddressTambol,
      homeAddressPostal: vHomePostalCode,
      presentAddressNo: vPresentAddressNo,
      presentAddressProvince: vPresentAddressProvince,
      // presentAddressProvince: { id: 8, codeSAP: '64', name: 'สิงห์บุรี' },
      presentAddressDistrict: vPresentAddressDistrict,
      presentAddressTambol: vPresentAddressTambol,
      presentAddressPostal: presentPostalCode,
      // medicalProblem: '',
      // workOnRemoteSite: '',
      // workOnRemoteSiteOccasion: '',
      // educations: [{ eduClass: '' }],
      // ------------------------------------
      educations: vEducation,

      // { eduNameAndPlace: edu[1]?.instituteName || '---' },
      // ------------------------------------
      // eduOnApplicant: '',
      // engineerCert: '',
      isCollegeActivity: '',
      // collegeActivity: [
      //   {
      //     dateFrom: '',
      //   },
      // ],
      // englishLanguageSkillSpeak: '',
      // englishLanguageSkillRead: '',
      // englishLanguageSkillWrite: '',
      // englishLanguageCertificate: '',
      // othersLanguageSkill: [{ speak: '' }],
      // othersLanguageSkill: [
      // {
      //   languageSkill: [{ id: '', codeSAP: '', name: '' }],
      //   speak: '',
      //   read: '',
      //   write: '',
      //   certificate: '',
      // },
      // {
      //   languageSkill: '2',
      //   speak: '2',
      //   read: '2',
      //   write: '2',
      //   certificate: '2',
      // },
      // ],
      // ------------------------------------
      othersLanguageSkill: [
        {
          languageSkill: {
            id: +skillLanguage[1]?.languageId || '',
            codeSAP: skillLanguage[1]?.codeSAP || '',
            name: skillLanguage[1]?.name || '',
          },
          speak: skillLanguage[1]?.speakingLevelId || '',
          read: skillLanguage[1]?.readingLevelId || '',
          write: skillLanguage[1]?.writingLevelId || '',
          // certificate: skillLanguage[1]?.certificate || '',
        },
      ],
      // ------------------------------------
      // trainingHistory: [{ companyName: '' }],
      // computerSkills: ['2', '3'],
      computerSkills: vComputerSkill?.split(',') || '',
      otherComputerSkill,
      militaryStatus: '',
      maritalStatus: '',
      acceptAgreement: [isPersonalDataProtectionAct ? '1' : '0'],
      empNationality:
        nationality == 'TH' || nationality == null ? 'ไทย' : nationality,
      placeOfBirth: vPlaceOfBirthProvince,
      medicalProblem: medicalProblem ? 'Y' : 'N',
      medicalProblemDetail: medicalProblem,
      presentAddressCellPhone: mobileNo,
      presentAddressEmail: email,
      emergencyTitle: emergencyTitle || '',
      emergencyFirstName,
      emergencyLastName,
      emergencyRelation: emergencyRelationship,
      emergencyAddress,
      emergencyPhone: emergencyMobileNo,
      workOnRemoteSite,
      workOnRemoteSiteOccasion,
      applicantId,
      eduOnApplicant: degreeCode,
      // ------------------------------------
      engineerCert: engineerCert[0] ? 'Y' : 'N',
      engineerCertNo: engineerCert[0]?.engineerCertNo || '',
      engineerCertProvider: engineerCert[0]?.engineerCertProvider || '',
      engineerCertStartDate: engineerCert[0]?.engineerCertStartDate || '',
      engineerCertEndDate: engineerCert[0]?.engineerCertEndDate || '',
      engineerCertMemberNo: engineerCert[0]?.engineerCertMemberNo || '',
      engineerCertType: engineerCert[0]?.engineerCertType || '',
      engineerCertBranch: engineerCert[0]?.engineerCertBranch || '',
      englishLanguageSkillSpeak: skillLanguage[0]?.speakingLevelId || '',
      englishLanguageSkillRead: skillLanguage[0]?.readingLevelId || '',
      englishLanguageSkillWrite: skillLanguage[0]?.writingLevelId || '',
      // englishLanguageCertificate: skillLanguage[0]?.certificate || '',
      // ------------------------------------
      isWorkExperience: (vWorkHistory && vWorkHistory.length > 0) ? 'Y' : 'N',
      workExperienceTotal: vWorkHistory?.length || 0,
      workExperience: vWorkHistory || [],
      trainingHistory: vTrainingHistory || '',
      comment: vComment || '',
      militaryStatus: vMilitaryStatus || '',
      militaryStatusReason: vMilitaryExceptReason || '',
      maritalStatus: marriageStatus || '0',
      spouseName,
      numberOfChildren,
      spouseOffice,
      spousePhone,
      birthdate,
      acceptConsent,
      empNo,
      signDate,
      salary,
      psArea,
      psGroup,
      startWorkDate,
      orgCode,
      empSection,
      empDepartment,
      empDivision,
      employmentRateId: vEmploymentRate,
      englishLanguageCertificate,
      englishLanguageCertificateScore,
      englishLanguageCertificateDate,
      englishLanguageCertificateNo,
      royalRankType,
      royalRank,
      workLocation,
      position: position
        ? position
        : getPositionShortName(`${positionText}ระดับ ${positionLevel}`),
      hrHead: vHrHead,
      hrChief: hrChief,

      // inOutCountry: ''
    };

    console.log(
      '----EmploymentHrInspection.jsx --> dataFromServer----',
      dataFromServer
    );

    //react-hook-form ใช้ reset() ในการ set ค่าเริ่มต้น
    // ใช้ setTimeout เพื่อให้แน่ใจว่า component ได้ mount แล้ว
    reset(dataFromServer);
    // setTimeout(() => {
    //   reset(dataFromServer, {
    //     keepDefaultValues: false,
    //     keepDirty: false
    //   });
    // }, 10000);
  };

  // return { ...previousState, formField: { lastname: 'sss' } };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    // fetch('https://jsonplaceholder.typicode.com/users')
    // fetch('http://localhost:3006/api/cis/province')
    fetch('/api/cis/province')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        console.log('Province data loaded');
        // ไม่ต้อง setIsLoading ที่นี่ เพราะจะรอให้ getEmployeeAndUpdate เสร็จก่อน
      })
      .catch((error) => {
        console.log('Error loading province:', error);
      });
  };

  const getEmployeeAndUpdate = async () => {
    // console.log('getEmployeeAndUpdate', currentUser.username);
    console.log(
      '---EmploymentHrInspection.jsx---getEmployeeAndUpdate---idCard---',
      idCard
    );
    // const { id } = useParams();
    // showLoader();
    try {
      // setErrorMessage('');
      // const { data } = await axios.get('/api/cis/employee', {
      //   params: { employeeId: idCard },
      // });

      const { data } = await UserService.getEmploymentByEmpNo(idCard);

      const {
        emp: { firstName: fname, lastName, presentAddress },
        edu: [{ durationOfCourse }],
      } = data;
      // const [
      //   {
      //     emp: { firstName: fname, lastName, presentAddress },
      //   },
      // ] = data;
      console.log(
        '---EmploymentHrInspection.jsx--getEmployeeAndUpdate 000 --> ',
        data
      );
      console.log(
        '---EmploymentHrInspection.jsx--getEmployeeAndUpdate 001 --> ',
        fname
      );
      console.log(
        '---EmploymentHrInspection.jsx--getEmployeeAndUpdate 002 -->durationOfCourse--> ',
        durationOfCourse
      );

      updateForm(data);
      
      // ประมวลผลเสร็จแล้ว ค่อยปิด loading
      setIsLoading(false);
    } catch (error) {
      console.log('Error :', error);
      setIsLoading(false);
    }
  };

  const getHonorsOptions = async () => {
    try {
      const { data } = await axios.get('/api/cis/honors');
      console.log('/api/cis/honors: ', data);
      setHonorsOptions(data);
    } catch (error) {
      console.log('Error :', error);
    }
  };

  // setIsLoading(false);
  // const {
  //   values: { firstName: f1, file1Name },
  // } = formikProps;
  // console.log('formikProps', f1);
  // const { values, submitForm } = useFormikContext();
  // if (!f1) formikProps.setFieldValue('firstName', fname);
  // if (!f1) formikProps.setFieldValue('file1Name', file1Name);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง'
  // );

  function _renderStepContent(step) {
    switch (step) {
      case 0:
        // getDataFromAPI();

        // ยังมีปัญหาเรื่อง performance เพราะ render ตลอด
        // console.log('_renderStepContent---case 0');

        //เคลียร์ค่าใน redux, แนบไฟล์
        // dispatch(
        //   setFileData({
        //     docType: 'file1Name',
        //     name: '',
        //     url: '',
        //   })
        // );

        // updateForm();
        return (
          <>
            {isLoading && (
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                {/* https://www.geeksforgeeks.org/how-to-use-circularprogress-component-in-reactjs/ */}
                <CircularProgress color="primary" />
              </div>
            )}
            {!isLoading && (
              <PersonalFormHrInspect
                formField={formField}
                rhf={rhf}
                idCard={idCard}
                // errors={errors}
                control={control}
              />
            )}
          </>
          // <PersonalForm formField={formField} />
        );
      // case 1:
      //   console.log('_renderStepContent---case 1');
      //   return <AddressForm formField={formField} rhf={rhf} />;
      // case 2:
      //   return <PaymentForm formField={formField} />;
      // case 3:
      //   return <ReviewOrder rhf={rhf} />;
      case 1:
        return <ReviewOrder rhf={rhf} />;
      default:
        return <div>Not Found</div>;
    }
  }

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // async function _submitForm(values, actions) {
  //   await _sleep(1000);
  //   alert(JSON.stringify(values, null, 2));
  //   actions.setSubmitting(false);

  //   //inset TO DB
  //   const isSuccess = await addEmployee(values);
  //   if (!isSuccess) {
  //     alert(errMsg);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //   }
  // }

  // function _handleSubmit(values, actions) {
  //   if (isLastStep) {
  //     _submitForm(values, actions);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //     actions.setTouched({});
  //     actions.setSubmitting(false);
  //   }
  // }

  //Hiring to SAP
  function _handleToSAP() {
    setIsSendingToSAP(true);
    const body = { employeeId: idCard };
    // const { educations } = body;
    axios
      .post('/api/cis/sap', body)
      .then(async (response) => {
        if (response.status == 200) {
          console.log('Success HiringToSAP');
          let msg = '';
          // ตรวจสอบว่ามี data structure หรือไม่
          if (!response.data || !response.data.data) {
            msg = `ส่งข้อมูลไป SAP ไม่สำเร็จ: ไม่มีข้อมูลตอบกลับจาก SAP`;
          }

          const {
            data: {
              data: { MSGTY, PERNR, ReturnMessages },
            },
          } = response;

          if (MSGTY === 'S') {
            const empno = PERNR?.slice(-6);
            const addEmpNO = await addEmployeeNo(empno);
            console.log('addEmpNO: ', addEmpNO);

            msg = `ส่งข้อมูลไป SAP สำเร็จ: ${PERNR?.slice(-6)}`;
          } else if (MSGTY === 'E') {
            msg = `ส่งข้อมูลไป SAP ไม่สำเร็จ: ${JSON.stringify(
              ReturnMessages
            )}`;
          } else {
            msg = `ส่งข้อมูลไป SAP: สถานะ ${MSGTY} - ${JSON.stringify(
              ReturnMessages
            )}`;
          }

          console.log(
            `response from HiringToSAP: ', ${JSON.stringify(ReturnMessages)}`
          );
          setSapErrorMsg(msg);
          handleClickOpenSapErrorDialog();
        }
        // alert(JSON.stringify({ body: body, response: response?.data?.data }));
        setIsSendingToSAP(false);
      })
      .catch((error) => {
        console.log('Error HiringToSAP: ', error);
        const msg =
          error.response?.data?.message ||
          error.message ||
          'เกิดข้อผิดพลาดในการส่งข้อมูลไป SAP';
        setSapErrorMsg(msg);
        handleClickOpenSapErrorDialog();
        setIsSendingToSAP(false);
      });
  }

  function _handleBack() {
    // setActiveStep(activeStep - 1);

    // ถ้าจะ scroll to บรรทัดเก่า, ยังไม่ได้ลอง
    // https://stackoverflow.com/questions/66975251/how-do-i-scroll-to-a-row-in-a-list-of-rows-using-react
    navigate(`/app/employment/hr-inspection`);
  }
  function _handleBackToR2() {
    // setActiveStep(activeStep - 1);

    // ถ้าจะ scroll to บรรทัดเก่า, ยังไม่ได้ลอง
    // https://stackoverflow.com/questions/66975251/how-do-i-scroll-to-a-row-in-a-list-of-rows-using-react
    navigate(`/app/employment/hr-inspection-emp/${idCard}`);
  }

  function _handleApprove() {}

  function _handleReject() {}

  //to backend: hr.cis.routes2.js --> CIS.js -- > insertOrUpdateEmployee
  const addEmployee = async (values) => {
    console.log('addEmployee---------->', values);

    try {
      // setErrorMessage('')
      // setIsLoading(true)
      const {
        positionType,
        applicantNo,
        title,
        idCard,
        firstName,
        lastName,
        address1,
        engTitle,
        nameEng,
        nickName,
        empWeight,
        empHeight,
        bloodType,
        homeAddressNo,
        homeAddressProvince,
        homeAddressTambol,
        homeAddressDistrict,
        homeAddressPostal,
        presentAddressNo,
        presentAddressProvince,
        presentAddressDistrict,
        presentAddressTambol,
        presentAddressPostal,
        empNationality,
        placeOfBirth,
        medicalProblem,
        medicalProblemDetail,
        presentAddressCellPhone,
        presentAddressEmail,
        emergencyTitle,
        emergencyFirstName,
        emergencyLastName,
        emergencyRelation,
        emergencyAddress,
        emergencyPhone,
        workOnRemoteSite,
        workOnRemoteSiteOccasion,
        educations,
        applicantId,
        eduOnApplicant,
        engineerCert,
        engineerCertNo,
        engineerCertProvider,
        engineerCertStartDate,
        engineerCertEndDate,
        engineerCertMemberNo,
        engineerCertType,
        engineerCertBranch,
        englishLanguageSkillSpeak,
        englishLanguageSkillRead,
        englishLanguageSkillWrite,
        englishLanguageCertificate,
        englishLanguageCertificateScore,
        englishLanguageCertificateDate,
        englishLanguageCertificateNo,
        othersLanguageSkill,
        otherComputerSkill,
        workExperience,
        isWorkExperience,
        trainingHistory,
        computerSkills,
        comment,
        militaryStatus,
        militaryStatusReason,
        maritalStatus,
        spouseName,
        numberOfChildren,
        spouseOffice,
        spousePhone,
        birthdate,
        acceptConsent,
        empDivision,
        signDate,
        startWorkDate,
        orgCode,
        empSection,
        empDepartment,
        employmentRateId,
        salary,
        psArea,
        psGroup,
        country,
        royalRankType,
        royalRank,
        workLocation,
        position,
        hrHead,
        empNo,
        // graduateDate,
        // inOutCountry
      } = values;

      // Format dates in educations array
      const formattedEducations = educations?.map((edu) => ({
        ...edu,
        dateFrom: edu.dateFrom
          ? formatDateYYYYMMDD(edu.dateFrom)
          : edu.dateFrom,
        dateTo: edu.dateTo ? formatDateYYYYMMDD(edu.dateTo) : edu.dateTo,
        graduateDate: edu.graduateDate
          ? formatDateYYYYMMDD(edu.graduateDate)
          : edu.graduateDate,
      }));

      // Format other date fields
      const formattedSignDate = signDate
        ? formatDateYYYYMMDD(signDate)
        : signDate;
      const formattedStartWorkDate = startWorkDate
        ? formatDateYYYYMMDD(startWorkDate)
        : startWorkDate;
      const formattedEngineerCertStartDate = engineerCertStartDate
        ? formatDateYYYYMMDD(engineerCertStartDate)
        : engineerCertStartDate;
      const formattedEngineerCertEndDate = engineerCertEndDate
        ? formatDateYYYYMMDD(engineerCertEndDate)
        : engineerCertEndDate;
      const formattedEnglishLanguageCertificateDate =
        englishLanguageCertificateDate
          ? formatDateYYYYMMDD(englishLanguageCertificateDate)
          : englishLanguageCertificateDate;

      const hrAddOn = {
        idCard,
        empNo: empNo && parseInt(empNo, 10) > 599355 ? empNo : '',
        signDate: formattedSignDate,
        startWorkDate: formattedStartWorkDate,
        orgCode,
        empSection,
        empDepartment,
        empDivision,
        employmentRateId,
        salary,
        psArea,
        psGroup,
        // workLocationCode: workLocation?.codeSAP || '',
        position,
        hrHeadCode: hrHead?.empNo,
      };

      console.log('HR FORM: ', hrAddOn);

      const data = await axios.post('/api/cis/add-employee', {
        params: {
          positionType,
          applicantNo,
          title,
          idCard,
          firstName,
          lastName,
          presentAddress: address1,
          engTitle,
          nameEng,
          nickName,
          empWeight,
          empHeight,
          bloodType,
          homeAddressNo, //ที่อยู่ตามทะเบียนบ้าน
          homeAddressProvince,
          homeAddressTambol,
          homeAddressDistrict,
          homeAddressPostal,
          presentAddressNo, //ที่อยู่ปัจจุบันที่สามารถติดต่อได้
          presentAddressProvince,
          presentAddressDistrict,
          presentAddressTambol,
          presentAddressPostal,
          empNationality,
          placeOfBirth,
          medicalProblem,
          medicalProblemDetail,
          presentAddressCellPhone,
          presentAddressEmail,
          emergencyTitle,
          emergencyFirstName,
          emergencyLastName,
          emergencyRelation,
          emergencyAddress,
          emergencyPhone,
          workOnRemoteSite,
          workOnRemoteSiteOccasion,
          educations: formattedEducations,
          applicantId,
          eduOnApplicant,
          engineerCert,
          engineerCertNo,
          engineerCertProvider,
          engineerCertStartDate: formattedEngineerCertStartDate,
          engineerCertEndDate: formattedEngineerCertEndDate,
          engineerCertMemberNo,
          engineerCertType,
          engineerCertBranch,
          englishLanguageSkillSpeak,
          englishLanguageSkillRead,
          englishLanguageSkillWrite,
          englishLanguageCertificate,
          englishLanguageCertificateScore,
          englishLanguageCertificateDate:
            formattedEnglishLanguageCertificateDate,
          englishLanguageCertificateNo,
          workExperience,
          isWorkExperience,
          trainingHistory,
          computerSkills,
          comment,
          militaryStatus,
          militaryStatusReason,
          maritalStatus,
          spouseName,
          numberOfChildren,
          spouseOffice,
          spousePhone,
          birthdate,
          hrUpdatedBy: currentUser.username,
          acceptConsent,
          otherComputerSkill,
          country,
          royalRankType,
          royalRank,
          hrAddOn,
          // isPersonalDataProtectionAct: acceptAgreement[0],
          // graduateDate,
          // inOutCountry
        },
      });
      console.log('---EmploymentHrInspection---addEmployee hr data', hrAddOn);
      console.log('---EmploymentHrInspection---addEmployee data', {
        positionType,
        applicantNo,
        title,
        idCard,
        firstName,
        lastName,
        presentAddress: address1,
        engTitle,
        nameEng,
        nickName,
        empWeight,
        empHeight,
        bloodType,
        homeAddressNo, //ที่อยู่ตามทะเบียนบ้าน
        homeAddressProvince,
        homeAddressTambol,
        homeAddressDistrict,
        homeAddressPostal,
        presentAddressNo, //ที่อยู่ปัจจุบันที่สามารถติดต่อได้
        presentAddressProvince,
        presentAddressDistrict,
        presentAddressTambol,
        presentAddressPostal,
        empNationality,
        placeOfBirth,
        medicalProblem,
        medicalProblemDetail,
        presentAddressCellPhone,
        presentAddressEmail,
        emergencyTitle,
        emergencyFirstName,
        emergencyLastName,
        emergencyRelation,
        emergencyAddress,
        emergencyPhone,
        workOnRemoteSite,
        workOnRemoteSiteOccasion,
        othersLanguageSkill,
        otherComputerSkill,
        educations: formattedEducations,
        applicantId,
        eduOnApplicant,
        engineerCert,
        engineerCertNo,
        engineerCertProvider,
        engineerCertStartDate,
        engineerCertEndDate,
        engineerCertMemberNo,
        engineerCertType,
        engineerCertBranch,
        englishLanguageSkillSpeak,
        englishLanguageSkillRead,
        englishLanguageSkillWrite,
        englishLanguageCertificate,
        englishLanguageCertificateScore,
        englishLanguageCertificateDate,
        englishLanguageCertificateNo,
        othersLanguageSkill,
        workExperience,
        isWorkExperience,
        trainingHistory,
        computerSkills,
        comment,
        militaryStatus,
        militaryStatusReason,
        maritalStatus,
        spouseName,
        numberOfChildren,
        spouseOffice,
        spousePhone,
        birthdate,
        hrUpdatedBy: currentUser.username,
        acceptConsent,
        hrAddOn,
        // isPersonalDataProtectionAct: acceptAgreement[0],
        // graduateDate,
        // inOutCountry
      });

      return true;
    } catch (error) {
      console.log('error-->frontend-->addEmployee', error);
      setErrMsg(JSON.stringify(error));

      return false;
    }
  };

  const addEmployeeNo = async (values) => {
    console.log('addEmployeeNo---------->', values);

    try {
      const data = await axios.put('/api/cis/add-employee', {
        params: {
          idCard,
          empNo: values,
        },
      });

      return true;
    } catch (error) {
      console.log('error-->frontend-->addEmployeeNo', error);
      setErrMsg(JSON.stringify(error));

      return false;
    }
  };

  // setErrorMessage('');
  // setIsLoading(false);
  // setNickname(nickname);
  // setNicknameInfo('กรุณาเข้าระบบใหม่อีกครั้ง');
  // setOpenNicknameDialog(false);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message ||
  //         'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  // );
  // console.log(error.response)

  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
  const [openSapErrorDialog, setOpenSapErrorDialog] = React.useState(false);

  const handleClickOpenErrorDialog = () => {
    setOpenErrorDialog(true);
  };
  const handleClickOpenSapErrorDialog = () => {
    setOpenSapErrorDialog(true);
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };
  const handleCloseSapErrorDialog = () => {
    setOpenSapErrorDialog(false);
  };

  // useEffect(() => {
  //   getDataFromAPI(); //test delay
  //   getEmployeeAndUpdate();
  // }, []);

  useEffect(() => {
    // console.log('----useEffect---idCard---' + idCard);
    setIsLoading(true); // เริ่มต้น loading
    getDataFromAPI(); // โหลดข้อมูล province (ไม่ต้องรอ)
    getHonorsOptions(); // โหลดข้อมูล honors (ไม่ต้องรอ)
    getEmployeeAndUpdate(); // โหลดข้อมูลพนักงานและ updateForm แล้วจะปิด loading เมื่อเสร็จ
  }, [idCard]);

  return (
    <React.Fragment>
      <Typography
        component="h1"
        variant="h6"
        align="left"
        sx={{ color: 'primary.main' }}
      >
        เจ้าหน้าที่ตรวจสอบข้อมูล
        {/* {JSON.stringify(isSubmittingFinal)} */}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <>
            <AlertMsg
              open={openSapErrorDialog}
              handleClose={handleCloseSapErrorDialog}
              errMsgDialog={sapErrorMsg}
            />
            <CheckoutSuccess />
            <div className={classes.buttons}>
              {/* <Button onClick={_handleBackToR2} className={classes.button}>
                กจ.2
              </Button> */}
              <div className={classes.wrapper}>
                <Button
                  onClick={_handleToSAP}
                  className={classes.button}
                  disabled={!!vEmpNo || isSendingToSAP}
                >
                  {isSendingToSAP ? 'กำลังส่งข้อมูล...' : 'SAP'}
                </Button>
                {isSendingToSAP && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </>
        ) : (
          // <Formik
          //   initialValues={formValues || formInitialValues}
          //   validationSchema={currentValidationSchema}
          //   enableReinitialize
          //   onSubmit={_handleSubmit}
          // >
          //   {({ isSubmitting }) => (

          <form onSubmit={handleSubmit(onSubmit, onError)}>
            {_renderStepContent(activeStep)}

            <SimpleDialog
              open={openErrorDialog}
              onClose={handleCloseErrorDialog}
            />

            <AlertMsg
              open={openSapErrorDialog}
              handleClose={handleCloseSapErrorDialog}
              errMsgDialog={sapErrorMsg}
            />
            <div className={classes.buttons}>
              {/* <Button onClick={_handleToSAP} className={classes.button} disabled={!!vEmpNo}>
                SAP
              </Button> */}
              <Button onClick={_handleBack} className={classes.button}>
                Back
              </Button>
              <div className={classes.wrapper}>
                {/* <Button
                  style={{ minWidth: '90px' }}
                  onClick={_handleApprove}
                  variant="contained"
                  color="success"
                  className={classes.button}
                >
                  อนุมัติ
                </Button>
                <Button
                  style={{ minWidth: '90px' }}
                  onClick={_handleReject}
                  variant="contained"
                  color="warning"
                  className={classes.button}
                >
                  ไม่อนุมัติ
                </Button> */}

                {/* </div> */}

                {/* <div className={classes.wrapper}> */}

                {/* </div> */}

                {/* {/* <div className={classes.wrapper}> */}

                <Button
                  disabled={isSubmittingFinal}
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                >
                  {isLastStep ? 'ส่งข้อมูลให้ HR' : 'Next'}
                </Button>
                {isSubmittingFinal && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </form>

          //   )}
          // </Formik>
        )}
      </React.Fragment>
    </React.Fragment>
  );
}
